export default __webpack_public_path__ + "static/media/jobBannerMobile.26103dcb.png";